import { useQuery } from "@tanstack/react-query";
import { zohoApi } from "zohoApi";
import { useZohoAuthContext } from "context/ZohoAuthContext";

const STALE_TIME = 60 * 60 * 1000; // 1 hour

const transformData = (data) => {
  return data?.map((el) => {
    const settingSchema = JSON.parse(el?.setting_schema || "{}");
    const moduleApi = settingSchema?.module?.api_name;
    const popupFields = settingSchema?.popupFields || [];
    const fieldApis = popupFields?.map((el) => el?.api_name);

    const startTimeFieldApi = settingSchema?.startTimeField?.api_name;
    if (startTimeFieldApi) {
      fieldApis.push(startTimeFieldApi);
    }

    const endTimeFieldApi = settingSchema?.endTimeField?.api_name;
    if (endTimeFieldApi) {
      fieldApis.push(endTimeFieldApi);
    }

    const startTimeDataType = settingSchema?.startTimeField?.data_type;
    const endTimeDataType = settingSchema?.endTimeField?.data_type;
    const eventColor = settingSchema?.eventColor;

    const queryObj = {
      moduleApi,
      fieldApis,
      startTimeFieldApi,
      endTimeFieldApi,
      startTimeDataType,
      endTimeDataType,
      eventColor,
    };

    return {
      ...settingSchema,
      setting_id: el?.setting_id,
      queryObj,
    };
  });
};

export const useEventConfigArray = ({ all } = {}) => {
  const { orgId, apiKey, dataCenterUrl } = useZohoAuthContext();
  const fetchEventConfogArray = Boolean(orgId && apiKey && dataCenterUrl);

  const {
    data: eventConfigArray,
    isLoading,
    isFetching,
  } = useQuery({
    queryKey: ["eventConfigArray"],
    staleTime: STALE_TIME,
    enabled: fetchEventConfogArray,
    queryFn: async () => {
      const { data } = await zohoApi?.config?.getConfigFromDB({
        orgId,
        apiKey,
        dataCenterUrl,
        settingApiName: "eventConfig",
      });

      const arr = transformData(data);

      return arr;
    },
  });

  if (!isLoading && !isFetching && fetchEventConfogArray) {
    if (all) {
      return eventConfigArray ?? [];
    } else {
      const filteredArr = eventConfigArray?.filter((el) => el?.enabledSetting);
      return filteredArr ?? [];
    }
  }
  return [];
};
